import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import { handleSessionExpired } from './utils/api'

const INACTIVITY_LIMIT_MS = 30 * 60 * 1000 // 30 minutes
const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll', 'wheel']

function updateLastActivity() {
	try {
		localStorage.setItem('Mina_last_activity', String(Date.now()))
		window.dispatchEvent(new CustomEvent('Mina_user_activity'))
	} catch (e) {
		// ignore storage errors
	}
}

function startInactivityTimer() {
	// update on visibility change (tab switch)
	document.addEventListener('visibilitychange', () => {
		if (!document.hidden) updateLastActivity()
	})

	// update on user interactions
	ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, updateLastActivity, { passive: true }))

	// periodic check every 60 seconds (less frequent to reduce overhead)
	setInterval(() => {
		try {
			// Skip inactivity checks on public pages.
			if (router && ['login', 'waiter_login', 'barcode_scanner', 'bill_detail', 'qr_scanner'].includes(router.currentRoute.value.name)) {
				return
			}

			const last = parseInt(localStorage.getItem('Mina_last_activity') || '0', 10)
			if (!last) return
			const now = Date.now()
			if (now - last > INACTIVITY_LIMIT_MS) {
				// perform logout and redirect to correct login page
				handleSessionExpired()
			} else if (store && store.state.token) {
				// If user is active, refresh token every 30 minutes (1800 seconds)
				const lastTokenRefresh = parseInt(localStorage.getItem('Mina_last_token_refresh') || '0', 10)
				if (now - lastTokenRefresh > 30 * 60 * 1000) { // 30 minutes
					store.dispatch('refreshToken').then(success => {
						if (success) {
							localStorage.setItem('Mina_last_token_refresh', String(now))
						}
					}).catch(err => {
						console.error('Token refresh failed:', err)
					})
				}
			}
		} catch (err) {
			console.error('Inactivity check error', err)
		}
	}, 60 * 1000) // Check every minute

	// initialize
	updateLastActivity()
}

createApp(App).use(store).use(router).mount('#app')

// Start tracking user activity after app mounts
startInactivityTimer()

/**
 * Global Modal Persistence:
 * Intercept clicks on modal backdrops to prevent accidental closing.
 * Targets elements with 'fixed inset-0' and 'backdrop-blur-sm' (standard modal overlay pattern).
 */
window.addEventListener('click', (e) => {
	const target = e.target
	if (
		target && 
		target.classList && 
		target.classList.contains('fixed') && 
		target.classList.contains('inset-0') && 
		target.classList.contains('backdrop-blur-sm')
	) {
		// Stop event from reaching local Vue handlers like @click.self
		e.stopImmediatePropagation()
		e.preventDefault()
	}
}, true) // Use capture phase to intercept BEFORE local handlers
